import { FC } from "react";
import { MapLegend, Section } from "@landtechnologies/components";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { MeasurementSystem } from "src/js/stores/user/store";

import { PerAreaPriceModes, PerUnitPriceModes, PriceModes } from "../../typings";
import { PricePaid } from "./PricePaid";
import { PricePerArea } from "./PricePerArea/PricePerArea";
import { ZooplaLegend } from "./Zoopla/ZooplaLegend";
import { isZoopla } from "../../util/isZoopla";

export interface LegendProps {
  priceMode: PriceModes;
  loadingDistributionData: boolean;
  distribution?: number[] | null;
  legendOpen: boolean;
  unitType: MeasurementSystem;
  toggleLegend: (v: boolean) => void;
}

export const Legend: FC<LegendProps> = ({
  priceMode,
  distribution,
  loadingDistributionData,
  legendOpen,
  unitType,
  toggleLegend,
}) => {
  const { t } = useTranslation();

  return (
    <MapLegend
      openDefault={legendOpen}
      onLegendToggle={toggleLegend}
      headerChildren={
        <span className="atlas-text-content-inverse-primary">
          {t("comparables.map.legend.title")}
        </span>
      }
    >
      <div className="atlas-p-3" data-testid="comparables-legend-content">
        <Section>
          {priceMode === PerUnitPriceModes.EP || priceMode === PerUnitPriceModes.PRICE ? (
            <PricePaid priceMode={priceMode} />
          ) : null}
          {priceMode === PerAreaPriceModes.EPPSM || priceMode === PerAreaPriceModes.PPSM ? (
            <PricePerArea
              priceMode={priceMode}
              loading={loadingDistributionData}
              distribution={distribution}
              unitType={unitType}
            />
          ) : null}
          {isZoopla(priceMode) ? <ZooplaLegend priceMode={priceMode} /> : null}
        </Section>
      </div>
    </MapLegend>
  );
};
